import { apiGet, apiPost, apiDelete } from '../api-client.ts';

export interface ListaPeriodiResult {
  periodi: string[];
}

export interface ConfrontoResult {
  nomeTabella: string;
  periodoNuovo: string;
  periodoPrec: string;
  nNuovi: number;
  nExAltro: number;
  nCessati: number;
  fromCache: boolean;
}

export interface RigaConfronto {
  id: number;
  codiceFiscale: string;
  cognome: string;
  nome: string;
  dataNascita: string | null;
  categoria: 'NUOVO' | 'EX_ALTRO' | 'CESSATO';
  sindacatoPrec: string | null;
  impresaId: number | null;
  impresaRagioneSociale: string | null;
  dataAssunzione: string | null;
  dataCessazione: string | null;
}

export interface RigheResult {
  righe: RigaConfronto[];
  count: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface RigheParams {
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  categoria?: 'NUOVO' | 'EX_ALTRO' | 'CESSATO';
  sindacatoPrec?: string;
}

export const confrontiApi = {
  listaPeriodi: (cassa: string) =>
    apiGet<ListaPeriodiResult>(`confronti/periodi?cassa=${encodeURIComponent(cassa)}`),

  calcola: (cassa: string, periodoNuovo: string, force = false) =>
    apiPost<ConfrontoResult>('confronti', { cassa, periodoNuovo, ...(force ? { force: true } : {}) }),

  reset: (nomeTabella: string) =>
    apiDelete<{ ok: boolean }>(`confronti/${encodeURIComponent(nomeTabella)}`),

  righe: (nomeTabella: string, params: RigheParams = {}) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== '') qs.set(k, String(v));
    }
    const url = `confronti/${encodeURIComponent(nomeTabella)}/righe${qs.toString() ? '?' + qs.toString() : ''}`;
    return apiGet<RigheResult>(url);
  },
};
